import { createSlice } from '@reduxjs/toolkit';
import { createDiscussionForumGrading, getListDiscussionForumGrading } from './discussionForumGradingThunk';
import { RootState } from '~/utils/redux/store';
import { DEFAULT_PAGE } from '~/utils/constants/common';
import { IDiscussionForumGrade } from '~/utils/interface/discussion';

interface DiscussionForumGradingState {
  discussionForumGrades: IDiscussionForumGrade[];
  isRefreshListDiscussionForumGrading: boolean;
  isLoadingCreateDiscussionForumGrading: boolean;
  currentPage: number;
  hasMore: boolean;
  isLoading: boolean;
}

const initialState: DiscussionForumGradingState = {
  discussionForumGrades: [],
  isLoadingCreateDiscussionForumGrading: false,
  isRefreshListDiscussionForumGrading: false,
  currentPage: DEFAULT_PAGE,
  hasMore: false,
  isLoading: false,
};

const discussionForumGradingSlice = createSlice({
  name: 'discussionForumGradingSlice',
  initialState,
  reducers: {
    setRefreshList(state, action) {
      state.discussionForumGrades = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getListDiscussionForumGrading.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getListDiscussionForumGrading.fulfilled, (state, action) => {
        state.discussionForumGrades = action.payload.responses;
        state.isLoading = false;
        state.hasMore = action.payload.pagination.page < action.payload.pagination.totalPages;
        state.currentPage = action.payload.pagination.page;
      })
      .addCase(getListDiscussionForumGrading.rejected, (state) => {
        state.isLoading = false;
      });

    // create
    builder
      .addCase(createDiscussionForumGrading.pending, (state) => {
        state.isLoadingCreateDiscussionForumGrading = true;
      })
      .addCase(createDiscussionForumGrading.fulfilled, (state, action) => {
        state.isRefreshListDiscussionForumGrading = !state.isRefreshListDiscussionForumGrading;
        state.isLoadingCreateDiscussionForumGrading = false;
      })
      .addCase(createDiscussionForumGrading.rejected, (state) => {
        state.isLoadingCreateDiscussionForumGrading = false;
      });
  },
});

// Action
export const discussionForumGradingAction = discussionForumGradingSlice.actions;

// Selectors
export const selectDiscussionForumGrades = (state: RootState) =>
  state.discussionForumGradingState.discussionForumGrades;

// Reducer
const discussionForumGradingReducer = discussionForumGradingSlice.reducer;
export default discussionForumGradingReducer;
